module.exports = __webpack_public_path__ + "static/media/pending.331e41ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/import-status-icons/pending.svg
// module id = 7678
// module chunks = 0